/* eslint-disable lingui/no-unlocalized-strings */
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import TestimonialCompanyLogo from '@/assets/images/testimonial-company.png';
import TestimonialImage from '@/assets/images/testimonial-photo.png';
import { Text, Title } from '@/components/typography';

const SignUpTestimonial = () => {
  return (
    <div className="hidden w-140 max-w-md rounded-lg bg-white px-6 py-12 text-center shadow-md lg:block xl:max-w-xl xl:px-12">
      <div className="flex flex-col items-center gap-8">
        <Title level={1} weight="light">
          <Trans>Sign up for a free account</Trans>
        </Title>
        <Text variant="headline" weight="light">
          <Trans>
            After creating your account, you can access your Channel99 tag anytime in the settings
            section of your dashboard.
          </Trans>
        </Text>
        <div className="mt-3 flex flex-col items-center gap-8">
          <Text variant="headline" weight="light">
            <Trans>
              “I like that we are able to see all of marketing's impact in one location. The
              implementation process was quick - you simply add the Channel99 tag to your website
              and let the data flow.”
            </Trans>
          </Text>
          <div className="flex items-center justify-center">
            <img
              className="size-14 rounded-full"
              src={TestimonialImage}
              alt={t`Carson Foreman photo`}
            />
            <div className="ml-4 flex flex-col items-start justify-start">
              <Text variant="body1" weight="semi-bold">
                Carson Foreman
              </Text>
              <Text variant="body1" weight="light">
                <Trans>Marketing Operations Manager</Trans>
              </Text>
            </div>
          </div>
          <img className="w-40" src={TestimonialCompanyLogo} alt={t`RadarFirst logo`} />
        </div>
      </div>
    </div>
  );
};

export default SignUpTestimonial;
